export default {
    account: {},
    codebooks: {}
}